import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@react-navigation/native";
import * as React from "react";
import { Animated, Platform, StyleSheet } from "react-native";
export default function HeaderTitle(_param) {
    var tintColor = _param.tintColor, style = _param.style, rest = _object_without_properties(_param, [
        "tintColor",
        "style"
    ]);
    var colors = useTheme().colors;
    return /*#__PURE__*/ _jsx(Animated.Text, _object_spread_props(_object_spread({
        accessibilityRole: "header",
        "aria-level": "1",
        numberOfLines: 1
    }, rest), {
        style: [
            styles.title,
            {
                color: tintColor === undefined ? colors.text : tintColor
            },
            style
        ]
    }));
}
var styles = StyleSheet.create({
    title: Platform.select({
        ios: {
            fontSize: 17,
            fontWeight: "600"
        },
        android: {
            fontSize: 20,
            fontFamily: "sans-serif-medium",
            fontWeight: "normal"
        },
        default: {
            fontSize: 18,
            fontWeight: "500"
        }
    })
});
